import { NotificationEnum } from "@graphql/generated/graphql.g";

import { getNotificationTypeLabel } from "./notificationTypes";

/** Explicit empty state when a notification has no linked employee (AF-551). */
export const NO_EMPLOYEE_IDENTIFIED = "No employee identified";

export const NOTIFICATION_REASON_LABELS: Record<NotificationEnum, string> = {
  [NotificationEnum.NonWhitelistedEmail]: "personal email",
  [NotificationEnum.SharedLogin]: "shared credential",
  [NotificationEnum.FileUpload]: "file uploaded to personal cloud",
  [NotificationEnum.AccessToUnapprovedApp]: "access to an unapproved app",
  [NotificationEnum.SaasDiscovered]: "new unsanctioned app",
  [NotificationEnum.InactivityRecorded]: "coverage drop",
  [NotificationEnum.Signup]: "account signup",
};

/**
 * Prefer the persisted reason from create time; fall back to type mapping for
 * older rows that predate AF-551.
 */
export const getNotificationReasonLabel = (
  reason: string | null | undefined,
  notificationType: NotificationEnum | string | null | undefined,
): string => {
  if (reason && reason.trim()) {
    return reason.trim();
  }

  if (!notificationType) {
    return getNotificationTypeLabel(notificationType);
  }

  return (
    NOTIFICATION_REASON_LABELS[notificationType as NotificationEnum] ??
    getNotificationTypeLabel(notificationType)
  );
};
